"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.config = void 0;
/**
 * @private
*/
const config = exports.config = {
  style: {
    marker: data => {
      const width = 50;
      const height = 16;
      const textSize = 14;
      return {
        className: 'marker-text',
        svg: {
          text: {
            value: data.value || '',
            x: width / 2,
            y: Math.round(height - (height - textSize * 0.7) / 2),
            size: textSize,
            style: 'bold',
            color: 'rgb(0,0,0)',
            autosize: true
          }
        },
        spacing: 20
      };
    }
  }
};
var _default = exports.default = config;